module.exports = __webpack_public_path__ + "static/media/lgm.61c710bf.jpg";